import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import BehavioralSelect from 'Components/UI/BehavioralFormElement/Select';
import { withHousehold } from 'Context/HouseholdContext';

import './index.css';
import { makeHideable } from '../Hideable';
import { ContextIndex } from './FieldList';
import withViewContext from './withViewContext';


class Select extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value, isReadonly },
      },
    } = props;

    this.state = {
      value,
      isReadonly: isReadonly === 'true',
      isDone: false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        const {
          props: { name, onChange, onMount },
        } = this;
        this.handleDisplay(res.attributes.value);
        let valueToPass;
        if (res.attributes.value === undefined) {
          valueToPass = '';
        } else {
          valueToPass = res.attributes.value;
        }
        onChange(name, valueToPass);
        onMount(name, valueToPass);

        this.setState({ value: res.attributes.value, isReadonly: res.attributes.isReadonly === 'true' });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  componentDidUpdate() {
    const { value } = this.state;
    this.handleDisplay(value);
  }

  onChange(name, value) {
    const {
      onChange, uploadValue, householdId, answerKey, cannotBlankFieldOut,
    } = this.props;

    const index = this.context;

    if (cannotBlankFieldOut && !value) {
      return;
    }

    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });

    this.setState({ value }, onChange(name, value));
  }

  handleDisplay(value) {
    const {
      props: { options },
    } = this;

    // Hide everything once:
    for (let n = 0; n < options.length; n += 1) {
      if ('showWhileSelected' in options[n]) {
        options[n].showWhileSelected.current.hide();
      }
      if ('showWhileUnselected' in options[n]) {
        options[n].showWhileUnselected.current.hide();
      }
    }

    // Show only what needs to be shown:
    for (let n = 0; n < options.length; n += 1) {
      if ('showWhileSelected' in options[n]) {
        if (options[n].id === value) {
          options[n].showWhileSelected.current.show();
        }
      }
      if ('showWhileUnselected' in options[n]) {
        if (options[n].id !== value) {
          options[n].showWhileUnselected.current.show();
        }
      }
    }
  }


  render() {
    const {
      onChange,
      props,
      props: { name, label },
      state: { value, isReadonly, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <label htmlFor={name}>{label}</label>
        <br />
        <BehavioralSelect
          {...props}
          disabled={isReadonly}
          onChange={onChange}
          value={value}
          test={label}
        />
      </div>
    );
  }
}

Select.contextType = ContextIndex;

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      showWhileSelected: PropTypes.instanceOf(Object),
      showWhileUnselected: PropTypes.instanceOf(Object),
    }),
  ),
  uploadValue: PropTypes.func.isRequired,
  householdId: PropTypes.number.isRequired,
  answerKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  onMount: PropTypes.func,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
  cannotBlankFieldOut: PropTypes.bool,
};
Select.defaultProps = {
  label: '',
  options: [],
  onChange: noop,
  onMount: noop,
  apiResponse: { attributes: {} },
  cannotBlankFieldOut: false,
};

const SelectInput = withHousehold(withQuestionnaireFuncs(withViewContext(Select)));

export default makeHideable(SelectInput);
